import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

/* CLIENT ORDER PAGES */
import ClientOrdersPage from "./pages/orders/client/ClientOrdersPage.jsx";
import ClientOrderCreatePage from "./pages/orders/client/ClientOrderCreatePage.jsx";
import ClientOrderDetailsPage from "./pages/orders/client/ClientOrderDetailsPage.jsx";
import EditOrderPage from "./pages/orders/client/EditOrderPage.jsx";

/* EMPLOYEE ORDER PAGES */
import EmployeeDashboardPage from "./pages/employee/EmployeeDashboardPage.jsx";
import EmployeeOrderDetailsPage from "./pages/orders/employee/EmployeeOrderDetailsPage.jsx";
import EmployeeOrderEditPage from "./pages/orders/employee/EmployeeOrderEditPage.jsx";
import EmployeeLegalOrdersPage from "./pages/employee/EmployeeLegalOrdersPage.jsx";
import EmployeeLayout from "./pages/employee/EmployeeLayout.jsx";
import EmployeeMissionControlPage from "./pages/employee/EmployeeMissionControlPage.jsx";
/* CORE */
import Home from "./components/Home.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import RegisterPage from "./pages/RegisterPage.jsx";
import ProfilePage from "./pages/ProfilePage.jsx";
import DashboardPage from "./pages/DashboardPage.jsx";
import ProfileCard from "./components/ProfileCard.jsx";
import Shipment from "./components/Shipment.jsx";
import EmployeeInvoiceList from "./pages/EmployeeInvoiceList.jsx";
import EmployeeInvoiceDetails from "./pages/EmployeeInvoiceDetails.jsx";
import EmployeeInvoiceCreate from "./pages/EmployeeInvoiceCreate.jsx";
import DeliveryHistoryPage from "./pages/DeliveryHistoryPage.jsx";
import DeliveryCostPage from "./pages/DeliveryCostPage.jsx";
import DeliveryRoutePage from "./pages/DeliveryRoutePage.jsx";
import TrackingNumberPage from "./pages/TrackingNumberPage.jsx";
import DigitalTwinShipmentPage from "./pages/admin/digitalTwin/DigitalTwinShipmentPage.jsx";
import SmartContractPage from "./pages/legalDepartment/SmartContractPage.jsx";
import WarehousePage from "./pages/logistics/WarehousePage.jsx";
import DriverPage from "./pages/logistics/DriverPage.jsx";
import DispatchCenterPage from "./pages/logistics/DispatchCenterPage.jsx";
import BlockchainExplorerPage from "./pages/admin/blockchain/BlockchainExplorerPage.jsx";
import AdminDigitalTwinPage from "./pages/admin/digitalTwin/AdminDigitalTwinPage.jsx";
import AdminTrustScorePage from "./pages/admin/trust/AdminTrustScorePage.jsx";
import AdminAIPredictionCenter from "./pages/admin/ai/AdminAIPredictionCenter.jsx";
import NotificationCenterPage from "./pages/admin/notifications/NotificationCenterPage.jsx";
import ExecutiveDashboardPage from "./pages/admin/executive/ExecutiveDashboardPage.jsx";
import SecurityCenterPage from "./pages/admin/security/SecurityCenterPage.jsx";
/* 2FA */
import TwoFactorEnablePage from "./pages/TwoFactorEnablePage.jsx";
import TwoFactorVerifyLoginPage from "./pages/TwoFactorVerifyLoginPage.jsx";
import TwoFactorAuthModePage from "./pages/TwoFactorAuthModePage.jsx";

/* PUBLIC */
import FeedbackPage from "./pages/FeedbackPage.jsx";
import RecoverPasswordPage from "./pages/RecoverPasswordPage.jsx";
import ResetPasswordPage from "./pages/NewPasswordPage.jsx";
import ForgotPasswordPage from "./pages/ForgotPasswordPage.jsx";
import LoginAgreementPage from "./pages/LoginAgreementPage.jsx";
import UserAgreementText from "./components/UserAgreementText.jsx";
import ShowcasePage from "./pages/ShowcasePage.jsx";
import GuestPage from "./pages/GuestPage.jsx";
/* CLIENT */
import ClientForm from "./components/ClientForm/ClientForm.jsx";
import DemandForecast from "./components/DemandForecast.jsx";
import PaymentPage from "./pages/PaymentPage.jsx";
import GeoFencePage from "./pages/GeoFencePage.jsx";
import MyShipmentsPage from "./pages/orders/client/MyShipmentsPage.jsx";
import ClientPage from "./pages/ClientPage.jsx";
import ClientInvoicesPage from "./pages/orders/client/ClientInvoicesPage.jsx";
import ClientIoTTrackingPage from "./pages/orders/client/ClientIoTTrackingPage.jsx";
import ClientDigitalTwinPage from "./pages/orders/client/ClientDigitalTwinPage.jsx";
import ClientSmartContractPage from "./pages/orders/client/ClientSmartContractPage.jsx";
/* PAYMENTS */
import PaymentCreatePage from "./pages/payments/PaymentCreatePage.jsx";
import PaymentSuccessPage from "./pages/payments/PaymentSuccessPage.jsx";
import PaymentCancelPage from "./pages/payments/PaymentCancelPage.jsx";

/* ADMIN */
import AdminPage from "./pages/AdminPage.jsx";
import AdminPanelPage from "./pages/AdminPanelPage.jsx";
import BlockchainLogPage from "./pages/BlockchainLogPage.jsx";
import AdminSecurityPage from "./pages/AdminSecurityPage.jsx";
import IoTMapPage from "./pages/admin/iot/IoTMapPage.jsx";
import IoTDevicesPage from "./pages/admin/iot/IoTDevicesPage.jsx";
import AdminGeoFencePage from "./pages/admin/geofence/AdminGeoFencePage.jsx";
import EmployeeAdminPage from "./pages/EmployeeAdminPage.jsx";
import PackageScanPage from "./pages/PackageScanPage.jsx";
import SendSmsComponent from "./components/SendSmsComponent.jsx";
import EncryptionPage from "./pages/admin/EncryptionPage.jsx";
import EncryptionKeyPage from "./pages/admin/EncryptionKeyPage.jsx";
import MovementAnalyticsPage from "./pages/MovementAnalyticsPage.jsx";
import RouteOptimizationPage from "./pages/RouteOptimizationPage.jsx";
import SmartDeliveryPage from "./pages/admin/SmartDeliveryPage.jsx";
import CargoTypePage from "./pages/CargoTypePage.jsx";
import BillingAnalyticsPage from "./pages/admin/BillingAnalyticsPage.jsx";
import IndividualClientDetailsPage from "./pages/admin/clients/IndividualClientDetailsPage.jsx";
import LegalEntityDetailsPage from "./pages/admin/clients/LegalEntityDetailsPage.jsx";
import LegalEntityProfilePage from "./pages/legal/LegalEntityProfilePage.jsx";
import LegalEntityPage from "./pages/LegalEntityPage.jsx";
import AdaptiveSecurityPage from "./pages/admin/AdaptiveSecurityPage.jsx";
import AdaptiveTrustEnginePage from "./pages/admin/AdaptiveTrustEnginePage.jsx";
import TrustHistoryPage from "./pages/admin/TrustHistoryPage.jsx";
import IoTLiveControlCenterPage from "./pages/admin/iot/IoTLiveControlCenterPage.jsx";
import AnalyticsCenterPage from "./pages/admin/analytics/AnalyticsCenterPage.jsx";
import AICommandCenterPage from "./pages/admin/ai/AICommandCenterPage.jsx";
import GlobalMonitoringCenterPage from "./pages/admin/monitoring/GlobalMonitoringCenterPage.jsx";
import SystemHealthCenterPage from "./pages/admin/system/SystemHealthCenterPage.jsx";
import AutonomousDecisionEnginePage from "./pages/admin/ai/AutonomousDecisionEnginePage.jsx";
import PredictiveLogisticsCenterPage from "./pages/admin/predictive/PredictiveLogisticsCenterPage.jsx";
import IntelligentTrustEnginePage from "./pages/admin/trust/IntelligentTrustEnginePage.jsx";
import GlobalOperationsCenterPage from "./pages/admin/operations/GlobalOperationsCenterPage.jsx";
import AdminMissionControlPage from "./pages/admin/AdminMissionControlPage.jsx";
import PlatformModulesPage from "./pages/PlatformModulesPage.jsx";
import PlatformModuleManagerPage from "./pages/admin/PlatformModuleManagerPage.jsx";
import WarehouseManagementPage from "./pages/logistics/WarehouseManagementPage.jsx";
/* ADMIN CLIENTS */
import ClientCreatePage from "./pages/admin/clients/ClientCreatePage.jsx";
import ClientListPage from "./pages/admin/clients/ClientListPage.jsx";
import ClientUpdatePage from "./pages/admin/clients/ClientUpdatePage.jsx";
import ClientDeletePage from "./pages/admin/clients/ClientDeletePage.jsx";

/* ADMIN LEGAL ENTITY */
import LegalEntityCreatePage from "./pages/admin/clients/LegalEntityCreatePage.jsx";
import LegalEntityListPage from "./pages/admin/clients/LegalEntityListPage.jsx";
import LegalEntityUpdatePage from "./pages/admin/clients/LegalEntityUpdatePage.jsx";
import LegalEntityDeletePage from "./pages/admin/clients/LegalEntityDeletePage.jsx";

/* LEGAL ENTITY CLIENT UI */
import LegalEntityOrdersPage from "./pages/orders/client/legal/LegalEntityOrdersPage.jsx";
import LegalEntityOrderCreatePage from "./pages/orders/client/legal/LegalEntityCreatePage.jsx";
import LegalEntityOrderDetailsPage from "./pages/orders/client/legal/LegalEntityOrderDetailsPage.jsx";
import LegalEntityShipmentsPage from "./pages/orders/client/legal/LegalEntityShipmentsPage.jsx";
import LegalLayout from "./pages/legal/LegalLayout.jsx";

/* ADMIN SECURITY */
import SystemLogViewer from "./components/Admin/SystemLogViewer.jsx";
import AnomalyDetectionPanel from "./components/Admin/AnomalyDetectionPanel.jsx";
import AnomalyPredictionView from "./components/Admin/AnomalyPredictionView.jsx";
import ThreatPredictionPanel from "./components/Admin/ThreatPredictionPanel.jsx";
import UserManagement from "./components/Admin/UserManagement.jsx";
import AdaptiveSecurityAuditPage from "./pages/admin/AdaptiveSecurityAuditPage.jsx";
/* LAYOUT & GUARDS */
import Layout from "./components/Layout.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import RequireRole from "./components/auth/RequireRole.jsx";

const ClientRoute = ({ isClient }) =>
    isClient ? <Outlet /> : <Navigate to="/dashboard" replace />;

function App() {
    const { token, user } = useAuth();
    const isAuthenticated = !!token;

    const role =
        user?.role?.toLowerCase() ||
        localStorage.getItem("role")?.toLowerCase() ||
        "";

    const isClient = role === "client" || role === "user";

    return (
        <Routes>
            {/* PUBLIC */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/recover-password" element={<RecoverPasswordPage />} />
            <Route path="/new-password" element={<ResetPasswordPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/agreement" element={<LoginAgreementPage />} />
            <Route path="/user-agreement-text" element={<UserAgreementText />} />
            <Route path="/showcase" element={<ShowcasePage />} />
            <Route path="/platform-modules" element={<PlatformModulesPage />} />
            <Route path="/guest" element={<GuestPage />} />
            {/* 2FA */}
            <Route path="/2fa/verify-login" element={<TwoFactorVerifyLoginPage />} />

            {/* STRIPE */}
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />


            {/* PROTECTED */}
            <Route
                element={
                    <ProtectedRoute>

                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route element={<RequireRole role={["admin", "administrator", "employee"]} />}>

                    <Route path="cargo-types" element={<CargoTypePage />} />
                    <Route path="autonomous-decision" element={<AutonomousDecisionEnginePage />} />



                </Route>
                <Route
                    path="dashboard"
                    element={
                        role === "legalentity" || role === "business" ? (
                            <Navigate to="/legal/profile" replace />
                        ) : role === "client" || role === "user" ? (
                            <Navigate to="/client" replace />
                        ) : role === "admin" || role === "administrator" ? (
                            <Navigate to="/admin" replace />
                        ) : role === "employee" ? (
                            <Navigate to="/employee/dashboard" replace />
                        ) : role === "dispatcher" ? (
                            <Navigate to="/dispatcher/dispatch-centers" replace />
                        ) : role === "legalofficer" ? (
                            <Navigate to="/legal-department/smart-contracts" replace />
                        ) : role === "warehousemanager" ? (
                            <Navigate to="/warehouse/warehouses" replace />
                        ) : role === "driver" ? (
                            <Navigate to="/driver/dashboard" replace />

                        ) : (
                            <Home />
                        )
                    }
                />

                {/* COMMON - ALL AUTHORIZED USERS */}
                <Route path="dashboard2" element={<DashboardPage />} />
                <Route path="enable-2fa" element={<TwoFactorEnablePage />} />
                <Route path="2fa/mode" element={<TwoFactorAuthModePage />} />
                {/* LEGAL ENTITY PROFILE - ADMIN + EMPLOYEE + LEGAL ENTITY */}
                <Route
                    element={
                        <RequireRole
                            role={["legalentity", "business", "admin", "administrator", "employee"]}
                        />
                    }
                >
                    <Route path="legal/profile" element={<LegalEntityProfilePage />} />
                    <Route path="legal-entity" element={<LegalEntityPage />} />
                </Route>

                {/* LEGAL ENTITY CLIENT UI - ONLY LEGAL ENTITY */}
                <Route element={<RequireRole role={["legalentity", "business"]} />}>
                    <Route element={<LegalLayout />}>
                        <Route path="legal/orders" element={<LegalEntityOrdersPage />} />
                        <Route path="legal/orders/create" element={<LegalEntityOrderCreatePage />} />
                        <Route path="legal/orders/:id" element={<LegalEntityOrderDetailsPage />} />
                        <Route path="legal/shipments" element={<LegalEntityShipmentsPage />} />
                        <Route path="legal/digital-twin" element={<ClientDigitalTwinPage />} />
                        <Route path="legal/iot-tracking" element={<ClientIoTTrackingPage />} />
                        <Route path="legal/smart-contracts" element={<ClientSmartContractPage />} />
                        <Route path="legal/delivery-price" element={<DeliveryCostPage />} />
                        <Route path="legal/geofence" element={<GeoFencePage />} />
                    </Route>
                </Route>
                {/* LEGAL OFFICER */}
                <Route element={<RequireRole role="legalofficer" />}>
                    <Route path="legal-department/smart-contracts" element={<SmartContractPage />} />
                    <Route path="legal-department/digital-twin" element={<DigitalTwinShipmentPage />} />
                </Route>
                {/* ADMIN */}
                <Route element={<RequireRole role={["admin", "administrator"]} />}>
                    <Route path="admin/dashboard" element={<AdminPage />} />
                    <Route path="admin-panel" element={<AdminPanelPage />} />
                    <Route path="admin/encryption" element={<EncryptionPage />} />
                    <Route path="admin/encryption-keys" element={<EncryptionKeyPage />} />
                    <Route path="admin/employees" element={<EmployeeAdminPage />} />
                    <Route path="admin/clients" element={<ClientListPage />} />
                    <Route path="admin/clients/create" element={<ClientCreatePage />} />
                    <Route path="admin/clients/update/:id" element={<ClientUpdatePage />} />
                    <Route path="admin/clients/delete/:id" element={<ClientDeletePage />} />
                    <Route path="movement" element={<MovementAnalyticsPage />} />
                    <Route path="admin/shipments" element={<Shipment />} />
                    <Route path="route-optimization" element={<RouteOptimizationPage />} />
                    <Route path="admin/smart-delivery" element={<SmartDeliveryPage />} />
                    <Route path="admin/package-scan" element={<PackageScanPage />} />
                    <Route path="admin/delivery-price" element={<DeliveryCostPage />} />
                    <Route path="admin/delivery-history" element={<DeliveryHistoryPage />} />
                    <Route path="admin/delivery-routes" element={<DeliveryRoutePage />} />
                    <Route path="admin/invoices" element={<EmployeeInvoiceList />} />
                    <Route path="admin/invoices/create" element={<EmployeeInvoiceCreate />} />
                    <Route path="admin/invoices/:id" element={<EmployeeInvoiceDetails />} />
                    <Route path="admin/geofence" element={<AdminGeoFencePage />} />
                    <Route path="admin/iot-map" element={<IoTMapPage />} />
                    <Route path="admin/iot-devices" element={<IoTDevicesPage />} />
                    <Route path="admin/tracking-numbers" element={<TrackingNumberPage />} />
                    <Route path="admin/security" element={<AdminSecurityPage />} />
                    <Route path="admin/security/log-viewer" element={<SystemLogViewer />} />
                    <Route path="admin/security/anomaly-detection" element={<AnomalyDetectionPanel />} />
                    <Route path="admin/security/anomaly-prediction" element={<AnomalyPredictionView />} />
                    <Route path="admin/security/threat-prediction" element={<ThreatPredictionPanel />} />
                    <Route path="admin/security/blockchain-logs" element={<BlockchainLogPage />} />
                    <Route path="admin/users" element={<UserManagement />} />
                    <Route path="admin/legal" element={<LegalEntityListPage />} />
                    <Route path="admin/legal/create" element={<LegalEntityCreatePage />} />
                    <Route path="admin/legal/update/:id" element={<LegalEntityUpdatePage />} />
                    <Route path="admin/legal/delete/:id" element={<LegalEntityDeletePage />} />
                    <Route path="admin/cargo-types" element={<CargoTypePage />} />
                    <Route path="admin/billing/analytics" element={<BillingAnalyticsPage />} />
                    <Route path="admin/clients/individual-clients/:id" element={<IndividualClientDetailsPage />} />
                    <Route path="admin/clients/:id" element={<LegalEntityDetailsPage />} />
                    <Route path="admin/adaptive-security" element={<AdaptiveSecurityPage />} />
                    <Route path="admin/adaptive-security/audits" element={<AdaptiveSecurityAuditPage />} />
                    <Route path="admin/adaptive-trust-engine" element={<AdaptiveTrustEnginePage />} />
                    <Route path="admin/trust-history" element={<TrustHistoryPage />} />
                    <Route path="admin/digital-twin/shipments" element={<DigitalTwinShipmentPage />} />
                    <Route path="admin/smart-contracts" element={<SmartContractPage />} />
                    <Route path="admin/warehouses" element={<WarehousePage />} />
                    <Route path="admin/drivers" element={<DriverPage />} />
                    <Route path="admin/dispatch-centers" element={<DispatchCenterPage />} />
                    <Route path="admin/demand-forecast" element={<DemandForecast />} />
                    <Route path="admin/sms" element={<SendSmsComponent />} />
                    <Route path="admin/blockchain-explorer" element={<BlockchainExplorerPage />} />
                    <Route path="admin/digital-twin" element={<AdminDigitalTwinPage />} />
                    <Route path="admin/trust-score" element={<AdminTrustScorePage />} />
                    <Route path="admin/ai-prediction-center" element={<AdminAIPredictionCenter />} />
                    <Route path="admin/notifications" element={<NotificationCenterPage />} />
                    <Route path="admin/executive-dashboard" element={<ExecutiveDashboardPage />} />
                    <Route path="admin/security-center" element={<SecurityCenterPage />} />
                    <Route path="admin/iot-control-center" element={<IoTLiveControlCenterPage />} />
                    <Route path="admin/analytics-center" element={<AnalyticsCenterPage />} />
                    <Route path="admin/ai-command-center" element={<AICommandCenterPage />} />
                    <Route path="admin/global-monitoring" element={<GlobalMonitoringCenterPage />} />
                    <Route path="admin/system-health" element={<SystemHealthCenterPage />} />
                    <Route path="admin/predictive-logistics" element={<PredictiveLogisticsCenterPage />} />
                    <Route path="admin/intelligent-trust-engine" element={<IntelligentTrustEnginePage />} />
                    <Route path="admin/global-operations" element={<GlobalOperationsCenterPage />} />
                    <Route path="admin/mission-control" element={<AdminMissionControlPage />} />
                    <Route path="admin" element={<AdminMissionControlPage />} />
                    <Route path="admin/warehouse-management" element={<WarehouseManagementPage />} />

                    <Route path="admin/platform-modules" element={<PlatformModuleManagerPage />} />

                </Route>

                {/* EMPLOYEE */}
                <Route element={<RequireRole role="employee" />}>
                    <Route element={<EmployeeLayout />}>
                        <Route path="employee/dashboard" element={<EmployeeDashboardPage />} />
                        <Route path="employee/legal-orders" element={<EmployeeLegalOrdersPage />} />
                        <Route path="employee/orders/:id" element={<EmployeeOrderDetailsPage />} />
                        <Route path="employee/orders/:id/edit" element={<EmployeeOrderEditPage />} />
                        <Route path="employee/package-scan" element={<PackageScanPage />} />
                        <Route path="employee/invoices" element={<EmployeeInvoiceList />} />
                        <Route path="employee/invoices/create" element={<EmployeeInvoiceCreate />} />
                        <Route path="employee/invoices/:id" element={<EmployeeInvoiceDetails />} />
                        <Route path="employee/tracking-numbers" element={<TrackingNumberPage />} />
                        <Route path="employee/delivery-price" element={<DeliveryCostPage />} />
                        <Route path="employee/delivery-history" element={<DeliveryHistoryPage />} />
                        <Route path="employee/delivery-routes" element={<DeliveryRoutePage />} />
                        <Route path="employee/movement" element={<MovementAnalyticsPage />} />
                        <Route path="employee/route-optimization" element={<RouteOptimizationPage />} />
                        <Route path="employee/smart-delivery" element={<SmartDeliveryPage />} />
                        <Route path="employee/legal/:id" element={<LegalEntityDetailsPage />} />
                        <Route path="employee/geofence" element={<GeoFencePage />} />
                        <Route path="employee/iot-devices" element={<IoTDevicesPage />} />
                        <Route path="employee/adaptive-security" element={<AdaptiveSecurityPage />} />
                        <Route path="employee/digital-twin" element={<DigitalTwinShipmentPage />} />
                        <Route path="employee/smart-contracts" element={<SmartContractPage />} />
                        <Route path="employee/warehouses" element={<WarehousePage />} />
                        <Route path="employee/drivers" element={<DriverPage />} />
                        <Route path="employee/dispatch-centers" element={<DispatchCenterPage />} />
                        <Route path="employee/demand-forecast" element={<DemandForecast />} />
                        <Route path="employee/sms" element={<SendSmsComponent />} />
                        <Route path="employee/ai-command-center" element={<AICommandCenterPage />} />
                        <Route path="employee/iot-control-center" element={<IoTLiveControlCenterPage />} />
                        <Route path="employee/global-monitoring" element={<GlobalMonitoringCenterPage />} />
                        <Route path="employee/analytics-center" element={<AnalyticsCenterPage />} />
                        <Route path="employee/autonomous-decision" element={<AutonomousDecisionEnginePage />} />
                        <Route path="employee/predictive-logistics" element={<PredictiveLogisticsCenterPage />} />
                        <Route path="employee/intelligent-trust-engine" element={<IntelligentTrustEnginePage />} />
                        <Route path="employee/global-operations" element={<GlobalOperationsCenterPage />} />
                        <Route path="employee/mission-control" element={<EmployeeMissionControlPage />} />
                        <Route path="employee/warehouse-management" element={<WarehouseManagementPage />} />


                    </Route>
                </Route>
                {/* DISPATCHER */}
                <Route element={<RequireRole role="dispatcher" />}>
                    <Route path="dispatcher/warehouses" element={<WarehousePage />} />
                    <Route path="dispatcher/warehouse-management" element={<WarehouseManagementPage />} />
                    <Route path="dispatcher/drivers" element={<DriverPage />} />
                    <Route path="dispatcher/dispatch-centers" element={<DispatchCenterPage />} />
                    <Route path="dispatcher/sms" element={<SendSmsComponent />} />
                    <Route path="dispatcher/demand-forecast" element={<DemandForecast />} />
                </Route>
                {/* WAREHOUSE MANAGER */}
                <Route element={<RequireRole role="warehousemanager" />}>
                    <Route path="warehouse/warehouses" element={<WarehousePage />} />
                    <Route path="warehouse/management" element={<WarehouseManagementPage />} />
                    <Route path="warehouse/drivers" element={<DriverPage />} />
                    <Route path="warehouse/dispatch-centers" element={<DispatchCenterPage />} />
                </Route>

                {/* DRIVER */}
                <Route element={<RequireRole role="driver" />}>
                    <Route path="driver/dashboard" element={<DriverPage />} />
                </Route>
                {/* CLIENT */}
                <Route element={<ClientRoute isClient={isClient} />}>
                    <Route path="client" element={<ClientPage />} />
                    <Route path="client/orders" element={<ClientOrdersPage />} />
                    <Route path="client/orders/create" element={<ClientOrderCreatePage />} />
                    <Route path="client/orders/:id" element={<ClientOrderDetailsPage />} />
                    <Route path="client/orders/:id/edit" element={<EditOrderPage />} />
                    <Route path="client/shipments" element={<MyShipmentsPage />} />
                    <Route path="client/invoices" element={<ClientInvoicesPage />} />
                    <Route path="client/iot-tracking" element={<ClientIoTTrackingPage />} />
                    <Route path="client/delivery-price" element={<DeliveryCostPage />} />
                    <Route path="client/geofence" element={<GeoFencePage />} />
                    <Route path="client-form" element={<ClientForm />} />
                    <Route path="payments" element={<PaymentPage />} />
                    <Route path="payments/create/:shipmentId" element={<PaymentCreatePage />} />
                    <Route path="profile" element={<ProfilePage />} />
                    <Route path="profile-card" element={<ProfileCard />} />
                    <Route path="client/digital-twin" element={<ClientDigitalTwinPage />} />
                    <Route path="client/smart-contract" element={<ClientSmartContractPage />} />

                </Route>
            </Route>

            {/* FALLBACK */}
            <Route
                path="*"
                element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />}
            />
        </Routes>
    );
}

export default App;